import { Button as StoreblocksButton } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';

interface Props {
  onClick: () => void;
  disabled?: boolean;

  /**
   * To be used by Styled Components.
   */
  className?: string;
}

const Button: FC<Props> = ({ onClick, disabled, className }) => {
  const texts = useTexts();

  return (
    <StoreblocksButton
      disabled={disabled}
      data-testid="remove-button"
      type="button"
      variant="tertiary"
      onClick={onClick}
      className={className}
      iconLeft="delete"
    >
      {texts.admin.remove}
    </StoreblocksButton>
  );
};

export const RemoveButton = styled(Button)`
  margin-left: 16px;
`;
